import axios from "utils/APIv2";

export const saveDdiSettings = async (data) => {
  const response = await axios.post("/ddi-settings", data);
  return response.data;
};

export const getDdiSettings = async () => {
  const response = await axios.get("/ddi-settings");
  return response.data;
};

export default {
  saveDdiSettings,
  getDdiSettings,
};
